/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import MESSANGER from '../BaseComponent/MESSANGER'
import InputMask from 'react-input-mask'
import TMS from '../BaseComponent/TMS'

class CreateOrganization extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }
  componentDidMount() {}

  addTemplate() {
    var title = document.getElementById('title').value
    var titleError = false
    var formError = false

    if (title === '') {
      titleError = true
      formError = true
      message.error('عنوان وارد شود')
    } else {
      if (!titleError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        title
      }

      http
        .post(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_CREATE}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('دپارتمان جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/base/report/tms/department')
            }, 2000)
          } else {
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت وظایف</li>
            <li>
              <Link to={'/base/report/tms/department'}>دپارتمان</Link>
            </li>
            <li>افزودن دپارتمان</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن دپارتمان</p>
            </div>
            <div className="formComponent">
              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="title" className="form-control" />

              <button className="btn btn-info btn-block" onClick={this.addTemplate.bind(this)}>
                ثبت دپارتمان
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default CreateOrganization
